import clsx from 'clsx';
import { useMemo } from 'react';

import Avatar from '../../../components/common/Avatar';
import AvatarPlaceholder from '../../../components/common/AvatarPlaceholder';
import { CommonAvatar } from '../../../types';

const MessageAvatarList = ({
  avatars,
  width = '40px',
  height = '40px',
  style = {},
  nameList,
}: {
  avatars: CommonAvatar[];
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  nameList?: Array<string>;
}) => {
  const nameListTitle = useMemo(() => nameList && nameList.join(', '), [nameList]);
  const [userAmount, avatar] = useMemo(() => {
    const userAmount = avatars && avatars.length > 1 ? avatars.length - 1 : 0;
    const avatar = avatars?.[0];
    return [userAmount, avatar];
  }, [avatars]);

  return (
    <div className={clsx([userAmount && 'message__thread__header-avatars-container'])}>
      <Avatar
        width={width}
        height={height}
        src={avatar?.url}
        fallbackString={avatar?.name?.trim() || ''}
      />
      {userAmount > 0 && (
        <AvatarPlaceholder
          stringToUse={`+${userAmount.toString()}`}
          style={{ width, height, ...style }}
          singleCharacter={false}
          title={nameListTitle}
        />
      )}
    </div>
  );
};

export default MessageAvatarList;
